export default __webpack_public_path__ + "static/puzzle-illustration@2x-da55691b6b1f92897d0fe7e2a073f1eb.png";